var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "over_layout" },
    [
      _c("section", { staticClass: "upgrade" }, [
        _c(
          "a",
          {
            staticStyle: { cursor: "pointer" },
            on: {
              click: function($event) {
                return _vm.$store.commit("paymentModal", true)
              }
            }
          },
          [_vm._v(_vm._s(_vm.$store.getters.t("create_resume")))]
        )
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "news_page" }, [
        _c(
          "div",
          { staticClass: "wrapper" },
          [
            _vm.post.id
              ? _c("bred-crumbs", { attrs: { navigation: _vm.navigateUrls() } })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "pages_header" }, [
              _c("div", { staticClass: "lines" }, [
                _c("h1", [_vm._v(_vm._s(_vm.post.name))])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "news_page_block" }, [
              _c("div", {
                staticClass: "all_news_block fr-view text_area",
                domProps: { innerHTML: _vm._s(_vm.post.content) }
              })
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("active-posts", { attrs: { posts: _vm.active_posts } }),
      _vm._v(" "),
      _c("div", { staticClass: "padding_bottom" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30ab1bc5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ab1bc5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/blog/Blog-detail.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-30ab1bc5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/blog/Blog-detail.vue
// module chunks = 0